export default class SelectRegion {
    constructor() {
        this.initEvents();
    }

    initEvents() {
        this.customSelect();
        this.setLanguageOnAction();
    }

    customSelect() {
        const selects = document.getElementsByClassName('select-region');

        for(let i = 0; i < selects.length; i++) {
            const options = selects[i].querySelector('.custom-options');
            let selectedOption = selects[i].querySelector('.selected');
            if (!selectedOption) {
                selectedOption = options.lastElementChild;
                selectedOption.classList.add('selected');
            }
            const placeholder = selects[i].querySelector('.custom-select__placeholder');
            placeholder.innerHTML = selectedOption.innerHTML;
            placeholder.setAttribute('data-lang', selectedOption.getAttribute('data-lang'));
            selects[i].style.backgroundImage = "url('/images/"+selects[i].querySelector('.custom-select__placeholder').getAttribute("data-lang").toUpperCase()+".svg'), url('/images/down-arrow-filled.svg')";
            const mapobserver = new MutationObserver(() => {
                placeholder.setAttribute('data-lang', selects[i].querySelector('.selected').getAttribute('data-lang'));
                selects[i].style.backgroundImage = "url('/images/"+selects[i].querySelector('.custom-select__placeholder').getAttribute("data-lang").toUpperCase()+".svg'), url('/images/down-arrow-filled.svg')";
            });
            mapobserver.observe(options, { attributes: true, childList: true, subtree: true });
        }
    }

    setLanguageOnAction() {
        const buttons = document.querySelectorAll('.change-language-on-click');
        for (let button of buttons) {
            button.addEventListener('click', e => {
                e.preventDefault();
                const lang = button.getAttribute('data-lang');
                localStorage.setItem('selected_language', lang);
                if (button.href) {
                    window.location.href = button.href;
                }
            });
        }
    }
}
